export default class estadisticaProxi {
    constructor(axios, url) {
        this.axios = axios;
        this.url = url;
    }

    /* //TODO LLAMADAS DE ESTADISTICA*/
    
    getByCurso(id) {
        return this.axios.get(this.url + `/estadistica/curso/${id}`);
    }

}